// extracted by mini-css-extract-plugin
module.exports = {"bb-hero-heading":"bb-hero-heading__rQqjZ"};